<div class="card-container mat-elevation-z1">
  <div class="card-content">
      <div>
          <mat-spinner *ngIf="loading"></mat-spinner>
         <app-patient-view-component *ngIf="!loading" [patientview]="patient"></app-patient-view-component>
      </div>
  </div>
</div>